import {
  CommonModule,
} from '@angular/common';

import {
  Component,
  OnInit,
} from '@angular/core';

import {
  ActivatedRoute,
  Router,
  RouterModule,
} from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

type PlanKey = 'starter' | 'business' | 'pro';

interface PricingPlan {

  key: PlanKey;

  nameKey: string;

  descriptionKey: string;

  price: number;

  recommended: boolean;

  featureKeys: string[];

}
@Component({
  selector: 'app-pricing',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.css'
})
export class PricingComponent {
registered = false;

  appId: number | null = null;

  selectedPlan: PricingPlan | null = null;


plans: PricingPlan[] = [
  {
    key: 'starter',
    nameKey: 'PRICING.PLANS.STARTER.NAME',
    descriptionKey: 'PRICING.PLANS.STARTER.DESCRIPTION',
    price: 19,
    recommended: false,
    featureKeys: [
      'PRICING.PLANS.STARTER.FEATURES.ONE_LOCATION',
      'PRICING.PLANS.STARTER.FEATURES.DIGITAL_MENU',
      'PRICING.PLANS.STARTER.FEATURES.PRODUCTS',
      'PRICING.PLANS.STARTER.FEATURES.MULTILANGUAGE',
      'PRICING.PLANS.STARTER.FEATURES.SUBDOMAIN',
      'PRICING.PLANS.STARTER.FEATURES.SUPPORT',
    ],
  },
  {
    key: 'business',
    nameKey: 'PRICING.PLANS.BUSINESS.NAME',
    descriptionKey: 'PRICING.PLANS.BUSINESS.DESCRIPTION',
    price: 39,
    recommended: true,
    featureKeys: [
      'PRICING.PLANS.BUSINESS.FEATURES.STARTER_ALL',
      'PRICING.PLANS.BUSINESS.FEATURES.ONLINE_ORDERS',
      'PRICING.PLANS.BUSINESS.FEATURES.REALTIME_ORDERS',
      'PRICING.PLANS.BUSINESS.FEATURES.KITCHEN_DISPLAY',
      'PRICING.PLANS.BUSINESS.FEATURES.STAFF',
      'PRICING.PLANS.BUSINESS.FEATURES.ANALYTICS',
      'PRICING.PLANS.BUSINESS.FEATURES.CUSTOM_DOMAIN',
      'PRICING.PLANS.BUSINESS.FEATURES.PRIORITY_SUPPORT',
    ],
  },
  {
    key: 'pro',
    nameKey: 'PRICING.PLANS.PRO.NAME',
    descriptionKey: 'PRICING.PLANS.PRO.DESCRIPTION',
    price: 79,
    recommended: false,
    featureKeys: [
      'PRICING.PLANS.PRO.FEATURES.BUSINESS_ALL',
      'PRICING.PLANS.PRO.FEATURES.MULTIPLE_LOCATIONS',
      'PRICING.PLANS.PRO.FEATURES.ADVANCED_ANALYTICS',
      'PRICING.PLANS.PRO.FEATURES.ROLES',
      'PRICING.PLANS.PRO.FEATURES.UNLIMITED_STAFF',
      'PRICING.PLANS.PRO.FEATURES.CENTRAL_MANAGEMENT',
      'PRICING.PLANS.PRO.FEATURES.API',
      'PRICING.PLANS.PRO.FEATURES.ONBOARDING',
    ],
  },
];


  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.registered =
      this.route.snapshot.queryParamMap.get(
        'registered',
      ) === 'true';
    const appId =
      this.route.snapshot.queryParamMap.get(
        'app_id',
      );

    this.appId = appId
      ? Number(appId)
      : null;
    this.selectedPlan =
      this.plans.find(
        (plan: PricingPlan) =>
          plan.key === 'business',
      ) ?? null;
  }

  selectPlan(plan: PricingPlan): void {
    this.selectedPlan = plan;
  }

  continueToDashboard(): void {
    void this.router.navigate(
      ['/'],
      {
        queryParams: {
          app_id: this.appId,
          plan: this.selectedPlan?.key,
        },
      },
    );
  }
}